var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"c-search-bar"},[_c('form',{staticClass:"input-wrap",attrs:{"onsubmit":"return false"}},[_c('svg',{staticClass:"m-style-svg m-svg-small"},[_c('use',{attrs:{"xlink:href":"#icon-search"}})]),_c('input',{attrs:{"placeholder":_vm.placeholder,"type":"search"},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }